import * as type from '../types/deliveries'

// \\ // \\ DELIVERIES CONTENT // \\ // \\

export const retrieveDeliveriesListings = payload => {
    return{
        type: type.REQUEST_DELIVERIES_LISTINGS,
        payload: payload
    }
}

export const resetDeliveriesListings = () => {
    return{
        type: type.RESET_DELIVERIES_LISTINGS
    }
}

// \\ // \\ CHANGE MODAL DISPLAYS // \\ // \\
export const changeDeliveriesModal = payload => {
    return{
        type: type.CHANGE_DELIVERIES_MODALS,
        modal: payload
    }
}

export const requestAddDelivery = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_DELIVERY,
        details: payload
    }
}

export const resetAddDelivery = () => {
    return{
        type: type.RESET_ADD_SINGLE_DELIVERY
    }
}